export const EI_EXCLUDED_REASON_IDS: number[] = [999, 11, 12, 1, 2, 3];
export const FIRST_INDEX: number = 0;
export const IN_REACH: string = 'In-reach';
export const OUT_OF_COMPLIANCE: string = 'Out of Compliance';
export const OUTREACH_METHOD_HOME_VISIT: number = 4;
export const OUTREACH_METHOD_SCHOOL_VISIT: number = 5;
export const PRESCHOOL_ALLOWED_REASON_IDS: number[] = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 13, 14, 15, 16, 17,
];
export const TWO_YEARS_DATE_COUNT: number = 2;
export const YES_VALUE: string = 'Yes';
